import { DateTime } from 'components/UI'
import { FC } from 'react'
import { getPositionName, getUserName } from 'services/Utilities'

type Props = {
  shift: MData.Event
  compact?: boolean
}

const ShiftItem: FC<Props> = ({ shift, compact }: Props) => {
  const { start, end, positionId, employeeId, isExtraShift } = shift

  // Return the shift information on one line
  if (compact) {
    return (
      <>
        {!!employeeId && getUserName(employeeId)}, {getPositionName(positionId)}{' '}
        <DateTime date={[start, end]} outFormat="time" range isExtraShift={isExtraShift} />
      </>
    )
  }

  return null
}

export default ShiftItem
